import React, { useState, useEffect } from 'react';

const LoadingSpinner = () => {
  const [textIndex, setTextIndex] = useState(0);
  const texts = [
    "Nog eventjes en dan kan het gas erop!",
    "En niet vergeten... blijven lachen!"
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTextIndex(prevIndex => (prevIndex === 0 ? 1 : 0));
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center p-8">
      {/* Spinner */}
      <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mb-6"></div>
      
      {/* Alternating text */}
      <p className="text-gray-600 text-center font-medium text-lg animate-fade-in">
        {texts[textIndex]}
      </p>
    </div>
  );
};

export default LoadingSpinner; 